import React, { useEffect, useState } from "react";
import { loadCaptchaEnginge, LoadCanvasTemplate, validateCaptcha, LoadCanvasTemplateNoReload } from 'react-simple-captcha';
import vrfy_gr_middle from '../images/view_gr_middle.png'
import { useParams, useLocation } from 'react-router-dom'
import vrfy_gr_mobile from '../images/gr_mobile.png'
import vrfy_gr_desktop from '../images/gr_desktop.png'
import { Document, Page, pdfjs } from 'react-pdf/dist/esm/entry.webpack';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import { makeStyles } from '@material-ui/core/styles';
import axios from "axios";
import PDF from "../images/test.pdf";
import PdfViewer from "./PdfViewer";
import Modal from 'react-bootstrap/Modal'

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;
 

const apiURL = `https://evrfy.ttlawcourts.org`;
//const apiURL = `http://localhost:4001`;





//Function to create Alerts +++++++++++++++++++++++++++++++++++++++++
function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

//Styles Override +++++++++++++++++++++++++++++++++++++++++
const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    '& > * + *': {
      marginTop: theme.spacing(2),
    },
  },
}));

//Query String parameters from URL +++++++++++++++++++++++++++++++++++++++++
function useQuery() {
  return new URLSearchParams(useLocation().search);
}




//BEGIN HERE +++++++++++++++++++++++++++++++++++++++++
const DownloadDocument = () =>{
  const classes = useStyles();
  const [DocumentError, setDocError] = React.useState(false);
  const [CaptchaError, setCaptchaError] = React.useState(false);
  const [AcCnError, setAcCnError] = React.useState(false);
  const [AllEmpty, setAllEmpty] = React.useState(false);
  const [fullscreen, setFullscreen] = useState(true);
  const [show, setShow] = useState(false);
  const [pdfDoc, setPdfDoc] = useState("");

  

  //Display Error through Snackbar
  const DisplayDocError = () => {
    setDocError(true);
  };

  const DisplayCpatchaError = () => {
    setCaptchaError(true);
  };

  const DisplayAllEmpty = () => {
    setAllEmpty(true);
  };

  const DisplayAcCnError = () => {
    setAcCnError(true);
  };

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setDocError(false);
    setCaptchaError(false);
    setAcCnError(false);
    setAllEmpty(false);
  };



  const { ac } = useParams();
  const { cn } = useParams();
  //console.log(ac)


  const [ac_value, setIvValue] = useState(ac?ac:"");
  const [cn_value, setContentValue] = useState(cn?cn:"");
  const [captcha_value, setCaptchaValue] = useState('');
  const [firstClick, setFirstClick] = useState(1);
  const [user_captcha_input, setUserCaptchaValue] = useState('');
 


  const onChangeCaptchaValue = (e) => {
    //console.log(e.target.value);
    setUserCaptchaValue(e.target.value);
    //console.log(user_captcha_value);
  }

  useEffect(() => {
    // Similar to componentDidMount
    let cv = loadCaptchaEnginge(6,'white','#222','lower');
  },
  [captcha_value]); // Only re-run the effect if captcha_value changes
            

  //clear the form
  const refreshData = () => {
    //setIvValue("");
    //setCaptchaError(false);
    //setContentValue("");
    let cv = loadCaptchaEnginge(6,'white','#222','lower');
    setUserCaptchaValue("")   
  }

  
    
    const getDoc = () => {
    var doc_to_download = `${apiURL}/api/downloads/${ac_value}/${cn_value}`;

    axios({
      url: doc_to_download,
      method: 'GET',
      responseType: 'blob', // important
    }).then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `${cn}-${ac}.pdf`);
      document.body.appendChild(link);
      link.click();
    })
    .catch(error => {
      DisplayDocError();
      console.log(error);
      return
    });
  }

  if (ac_value !="" && cn_value !="" && firstClick == 1) 
  {
    setFirstClick(0) 
    console.log(firstClick)
    //getDoc();
    
     }






  



  //Attempt to find Document
  //--------------------------------------------------------------------------
    const downloadDoc = () => {
      //console.log(pdfDoc);
      //First check to see if input values exist and are correct---------------
      let tmp_usr_captcha = document.getElementById('user_captcha_input').value;
      let user_captcha_value = tmp_usr_captcha.toLowerCase();


      
      if (validateCaptcha(user_captcha_value)==false) {
        DisplayCpatchaError();
        return;
      }

      //setCaptchaError(true);


      //clear the input fields ---------------
      refreshData();
      //--------------------------------------

      getDoc();
                
    }
  
    
    return (

      <div>






      <div className="vrfy-section get-doc">




      <div className="container">


        <div className="row">
          <div className="col-sm vrfy-form-wrapper">
          <div className="submit-form">

            <Snackbar open={DocumentError} autoHideDuration={3000} onClose={handleClose}>
              <Alert onClose={handleClose} severity="error">
                Document could not be found
              </Alert>
            </Snackbar>

            <Snackbar open={CaptchaError} autoHideDuration={3000} onClose={handleClose}>
              <Alert onClose={handleClose} severity="error">
                Incorrect Captcha value.
              </Alert>
            </Snackbar>

            <Snackbar open={AcCnError} autoHideDuration={3000} onClose={handleClose}>
              <Alert onClose={handleClose} severity="error">
                Incorrect Access Code and/or Case Number.
              </Alert>
            </Snackbar>

            <Snackbar open={AllEmpty} autoHideDuration={3000} onClose={handleClose}>
              <Alert onClose={handleClose} severity="error">
                All fields are required.
              </Alert>
            </Snackbar>


            {false ? (
              <div>
              
                
              </div>
            ) : (

              //VERIFY DOCUMENT FORM
              //+++++++++++++++++++++++++++++++++
              //+++++++++++++++++++++++++++++++++
              <div className="vrfy-document-form">
                            <h2 className="download-header"> <strong  className="s-b">Download</strong></h2>
                            {/* <p className="dl">Your download will begin automatically. <br/>If your are experiencing difficulty, 
                            please enter the captcha code in the box below and click "Download".</p> */}
                            <p className="dl">Please enter the captcha code in the box below and click "Download".</p>

                  
                
            

                  

                  <div><LoadCanvasTemplateNoReload className="captcha-canvas" /></div>
                  
                  <div  className="form-group vrfy-captcha">
                    <input
                      type="text"
                      className="form-control captcha-value"
                      id="user_captcha_input"
                      autoComplete="off"
                      required
                      value = {user_captcha_input}
                      onChange={onChangeCaptchaValue}
                      name="user_captcha_input"
                    />
                    <div className="lc">Enter code above with no spaces.</div>
                  </div>
                  
                  <div className="submit-row">
                    <button onClick={downloadDoc} className="btn btn-success">
                      <strong>Download</strong>
                    </button>
                  </div>
              </div>

              
            )}

          </div>
        </div>
          
        </div>
      </div>
      </div>


      
      {/* SECTION - HOW TO */}
      {/* +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++ */}
      {/* +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++ */}
      {/* +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++ */}
     
    </div>
      
    );


};

export default DownloadDocument;

